<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_690" data-name="Rectangle 690" width="148.809" height="260.125" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Are_you_greenwashing_or_or_are_you_the_real_deal_" data-name="Are you greenwashing or or are
you the real deal?" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">Are you greenwashing or are</tspan>
        <tspan x="0" y="28">you the real deal?</tspan>
    </text>
    <text id="_The_pressure_is_mounting._Purpose_ESG_and_sustainability_are_increasingly_important_to_your_positioning._Make_sure_your_ideas_stand_up_to_the_test:_Is_it_what_the_customer_wants_"
          data-name="​​The pressure is mounting. Purpose, ESG and sustainability are increasingly important to your positioning. Make sure your ideas stand up to the test:

Is it what the customer wants?" transform="translate(40 121)" fill="#fff" font-size="24"
          font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">​​The pressure is mounting.</tspan>
        <tspan x="0" y="51">Purpose, ESG and sustainability</tspan>
        <tspan x="0" y="79">are increasingly important to</tspan>
        <tspan x="0" y="107">your positioning. Make sure your</tspan>
        <tspan x="0" y="135">ideas stand up to the test:</tspan>
        <tspan x="0" y="163"></tspan>
        <tspan x="0" y="191">Is it what the customer wants?</tspan>
    </text>
    <g id="Group_1354" data-name="Group 1354" transform="translate(119 343)">
        <g id="Group_1353" data-name="Group 1353" clip-path="url(#clip-path)">
            <path id="Path_14689" data-name="Path 14689"
                  d="M96.308,34.936A59.617,59.617,0,0,1,117.1,48.451V48.5a59.555,59.555,0,1,1-84.223,0l1.684-1.666A59.328,59.328,0,0,1,72.79,31.048"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14690" data-name="Path 14690"
                  d="M109.262,138.866a23.1,23.1,0,0,0-19.356-22.794,23.713,23.713,0,0,1-28.82-.14A23.1,23.1,0,0,0,40.72,138.866"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14691" data-name="Path 14691"
                  d="M53.592,93.835A21.962,21.962,0,1,1,75.554,115.8,21.962,21.962,0,0,1,53.592,93.835Z" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14692" data-name="Path 14692"
                  d="M58.285,14.732C58.165,6.3,66.737,1,74.531,1c10,0,19.282,8.928,16.743,19.288C89,29.546,76.477,31.385,73.7,40.67a22.665,22.665,0,0,0-.64,6.434m1.083,3.979a3.866,3.866,0,0,1,3.848,3.783,3.935,3.935,0,0,1-2.344,3.7,3.775,3.775,0,0,1-5.255-3.53A3.854,3.854,0,0,1,74.142,51.083Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14693" data-name="Path 14693"
                  d="M1,180.855c4.7-13.689,18.118-22.081,32.213-22.081a60.726,60.726,0,0,1,18.01,2.829c4.685,1.356,8.393,2.537,13.306,2.537l20.044-.612c8.461,0,13.842,7.8,9.863,14.837,9.754-.6,20.02-5.706,27.745-11.511,4.636-3.484,8.813-7.642,13.909-10.409,2.027-1.1,4.353-1.987,6.6-1.484,14.539,3.253-6.1,22.631-10.342,26.249-15.119,12.907-38.855,31.2-59.841,31.2-11.7,0-23.082-2.523-34.662-3.771-8.74-.942-26.914-3.853-28.6,8.821m35.879-31.978a3.759,3.759,0,0,0,1.453.207l38.267-1.64h0a11.4,11.4,0,0,0,9.555-5.786"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7873" data-name="Line 7873" y2="5.068" transform="translate(9.531 224.775)" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7874" data-name="Line 7874" x2="0.282" y2="22.806" transform="translate(9.39 236.319)"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
    </g>
</svg>
